export default __webpack_public_path__ + "assets/images/logo.8a4cfbfd1afd183401cb181b177e4508.svg";